export type ComponentRef = Function | HTMLElement | string | null

export interface NestModalOptions<T extends ComponentRef = ComponentRef> {
  component: T;

  title?: string;
  content?: string;
}
